import { render, staticRenderFns } from "./Inscripciones.vue?vue&type=template&id=cf9ef114&scoped=true"
import script from "./Inscripciones.vue?vue&type=script&lang=js"
export * from "./Inscripciones.vue?vue&type=script&lang=js"
import style0 from "./Inscripciones.vue?vue&type=style&index=0&id=cf9ef114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9ef114",
  null
  
)

export default component.exports